import React, { Suspense, useState } from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { AppContextProvider } from "./AppContext/App.context";
import appReducer from "./AppContext/reducers/reducer";
import { ToastContextProvider } from "./components/Toast/Toast.context";
import { ToastRightContextProvider } from "./components/ToastRight/ToastRight.context";
import toastReducer from "./components/Toast/reducers/reducer";
import toastRightReducer from "./components/ToastRight/reducers/reducer";
import useLocalStorage from "./utils/localStorage";
import "./i18n";
import PageLoader from "./components/pageLoader/pageLoader";

// import {
//   initializeFirebase,
//   askForPermissionToReceiveNotificaitons,
// } from "./push-notification";

const localStorageObject = useLocalStorage;

ReactDOM.render(
  // <React.StrictMode> </React.StrictMode>
  <Suspense fallback={<PageLoader></PageLoader>}>
    <BrowserRouter>
      <AppContextProvider reducer={appReducer}>
        <ToastContextProvider reducer={toastReducer}>
          <ToastRightContextProvider reducer={toastRightReducer}>
            <App />
            {/* </MuiThemeProvider> */}
          </ToastRightContextProvider>
        </ToastContextProvider>
      </AppContextProvider>
    </BrowserRouter>
  </Suspense>,
  document.getElementById("root")
);
// initializeFirebase();
// if (!localStorage.getItem("device_token")) {
//   askForPermissionToReceiveNotificaitons();
// }
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// eslint-disable-next-line no-use-before-define
serviceWorker.register({
  onSuccess: (serviceWorkerRegistration) => {},
  onUpdate: (serviceWorkerRegistration) => {
    const registrationWaiting = serviceWorkerRegistration.waiting;
    if (registrationWaiting) {
      registrationWaiting.postMessage({ type: "SKIP_WAITING" });
      registrationWaiting.addEventListener("statechange", (e: any) => {
        // eslint-disable-next-line no-use-before-define
        if (e.target.state === "activated") {
          window.location.reload(true);
        }
      });
    }
  },
});
